import React, { useState } from 'react'
import { Modal, Loader, Message, Row, IconButton, Icon } from 'rsuite'
import ViewButton from '../../buttons/viewButton/ViewButton'
import { getCheckCancelApprover } from '../../../redux/actions/approveProject'
import notification from '../../../utils/notification'
import CancelApproverListDetail from './CancelApproverListDetail'
import CancelButton from '../../buttons/cancelButton/CancelButton'

const CancelApprovalList = ({
  approveType,
  projectversionId,
  header,
  style,
  contractModifyType,
  disabled,
  buttontext,
  onSuccess,
  requestId,
}) => {
  const [approverList, setApproverList] = useState([])
  const [formSchema, setFormSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowApproverList, setIsShowApproverList] = useState(false)

  const handleCallServiceVerifyApprover = async () => {
    if (Array.isArray(contractModifyType) && contractModifyType.length === 0) {
      notification.open('error', {
        title: '',
      })
      return
    }
    setIsLoading(true)
    setIsError(false)

    // try {
    //   const response = await getCheckCancelApprover(projectversionId, approveType,requestId)
    //   console.log('555==>',response)
    //   if (response) {
    //     setIsShowApproverList(true)
    //     setApproverList(response?.model?.values)
    //     setFormSchema(response)
    //   } else {
    //     setApproverList([])
    //   }
    // } catch (error) {
    //   setIsError(true)
    // } finally {
    //   setIsLoading(false)
    // }
    try {
      const response = await getCheckCancelApprover(projectversionId, approveType, requestId)
      // console.log('response ===>', response)

      const list = response?.model?.values
      setApproverList(Array.isArray(list) ? list : [])

      setFormSchema(response ?? { model: {} })

      setIsShowApproverList(true)
    } catch (error) {
      console.error('❌ Error in handleCallServiceVerifyApprover:', error)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {/* <CancelButton
        icon="edit"
        onClick={() => {
          handleCallServiceVerifyApprover()
          // setApproveType(1)
          // setIsShowApproverList(true)
        }}
        style={style}
        disabled={disabled}
      >
        {buttontext || 'ยกเลิกขอสายอนุมัติ'}
      </CancelButton> */}

      <IconButton
        onClick={() => {
          handleCallServiceVerifyApprover()
        }}
        disabled={disabled}
        appearance="ghost"
        className="rs-btn-ghost-edit"
        style={style}
        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
      >
        {buttontext || 'ยกเลิกขอสายอนุมัติ'}
      </IconButton>

      <Modal
        backdrop="static"
        full
        show={isShowApproverList}
        onHide={() => {
          setIsShowApproverList(false)
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ paddingTop: 10 }}>{header || 'รายชื่อสายอนุมัติ'}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* {isLoading && <Loader center content="กำลังโหลด..." />}
          {isError && (
            <Message showIcon type="error" header="เกิดข้อผิดพลาด">
              ไม่สามารถโหลดรรายชื่อสายอนุมัติได้
            </Message>
          )}
          {!isLoading && !isError && ( */}
          <CancelApproverListDetail
            dataList={approverList}
            formSchema={formSchema}
            approveType={approveType}
            projectversionId={projectversionId}
            isShow={isShowApproverList}
            setIsShow={setIsShowApproverList}
            onSuccess={onSuccess}
            requestId={requestId}
          />
          {/* )} */}
        </Modal.Body>

        <Modal.Footer>
          {/* <SaveButton onClick={handleSubmit(onSubmit)}>ยืนยัน</SaveButton>
          <CancelButton
            onClick={() => {
              setIsShowApproverList(false)
            }}
          >
            ปิด
          </CancelButton> */}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CancelApprovalList
